<div *ngIf="!renaming"
     class="flex h-[4rem] items-center justify-between rounded-[0.5rem] border border-medium bg-secondary px-[1rem]
            py-[0.5rem]">
  <div class="flex items-center gap-x-[1rem] max-w-[calc(100%-3rem)]">
    <div class="min-w-0 truncate font-bold">{{ fullName }}</div>
    <button (click)="startRenaming()"
            [disabled]="(renameDocumentIsLoading$ | async) === true"
            mat-icon-button>
      <mat-icon class="icon-brand icon-20" svgIcon="edit"></mat-icon>
    </button>
  </div>
  <ng-container *ngIf="downloadEnabled">
    <button (click)="downloadDocument()"
            *ngIf="(documentDownloadId$ | async) !== documentId"
            mat-icon-button>
      <mat-icon class="icon-brand icon-20"
                svgIcon="download"></mat-icon>
    </button>
    <mat-spinner *ngIf="(documentDownloadId$ | async) === documentId"
                 class="spinner-brand"
                 diameter="20"></mat-spinner>
  </ng-container>
</div>

<div *ngIf="renaming"
     class="flex h-[4rem] items-center gap-x-[1rem] rounded-[0.5rem] border border-medium bg-secondary pl-[0.5rem]
            pr-[1rem] py-[0.5rem]">
  <div class="flex min-w-0 flex-1 items-center gap-x-[0.1rem]">
    <div class="flex flex-1 items-center rounded-[0.5rem] border border-medium bg-primary p-[0.4rem]">
      <input (keydown.enter)="confirmRenameOnEnter($event)"
             [formControl]="control"
             class="min-w-0 flex-1 bg-transparent font-bold outline-none"
             matInput required />
    </div>
    <div class="shrink-0 font-bold text-secondary">.{{ extension }}</div>
  </div>
  <button (click)="cancelRenaming()"
          [disabled]="(renameDocumentIsLoading$ | async) === true"
          mat-icon-button>
    <mat-icon class="icon-20 icon-secondary" svgIcon="cross"></mat-icon>
  </button>
  <button (click)="confirmRename()"
          mat-icon-button>
    <mat-icon class="icon-20 icon-brand" svgIcon="check"></mat-icon>
  </button>
</div>
